import { find } from 'lodash/fp';
import React, { useState } from 'react';

import { useActiveDeviceCommands } from '@portals/api/organizations';
import { ButtonWidget, ButtonWidgetFormType } from '@portals/device-widgets';

import {
  useDeviceCommand,
  useSendCommandWithApproval,
} from '../../../../../../../hooks/commands';
import { WidgetProps } from '../device-widgets.types';

export function ButtonWidgetWrapper({
  widget,
  deviceId,

  isDeviceOffline,
  lastUpdateTimestamp,
}: WidgetProps<ButtonWidgetFormType>) {
  const fields = widget?.config?.fields;

  const sendCommandWithApproval = useSendCommandWithApproval();
  const activeCommands = useActiveDeviceCommands(deviceId);

  const [isLoading, setIsLoading] = useState(false);

  const { name, color, icon_name, show_icon, command_name } = fields ?? {};
  const command = useDeviceCommand(deviceId, command_name);

  const onClick = async () => {
    try {
      const commandResponse = await sendCommandWithApproval({
        deviceIds: [deviceId],
        command,
        extra_params: {},
      });

      if (commandResponse[0]?.tunnel_authenticate_url) {
        try {
          setIsLoading(true);

          setTimeout(() => {
            setIsLoading(false);

            window.open(commandResponse[0].tunnel_authenticate_url, '_blank');
          }, 3000);
        } catch (error) {
          console.error(error);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  const isActive = !!find({ name: command_name }, activeCommands.data);

  return (
    <ButtonWidget
      title={name}
      color={color}
      iconName={icon_name}
      showIcon={show_icon}
      onClick={onClick}
      isLoading={isActive || isLoading}
      isDeviceOffline={isDeviceOffline}
      lastUpdateTimestamp={lastUpdateTimestamp}
    />
  );
}
